import { useMemo } from 'react';
import { useUser } from '@/contexts/UserContext';
import { OrgType, Role } from '@/shared/types/userRoleTypes';
import {
  isCustomerUserProfile,
  isPlatformUserProfile,
  isTenantUserProfile,
} from '@/shared/utils/auth-utils';

export const useUserRoles = () => {
  const { orgRole, currentUser } = useUser();

  const isPlatformUser = useMemo(
    () => orgRole?.startsWith(`${OrgType.PLATFORM}_`) || isPlatformUserProfile(currentUser),
    [orgRole, currentUser],
  );

  const isTenantUser = useMemo(
    () => orgRole?.startsWith(`${OrgType.TENANT}_`) || isTenantUserProfile(currentUser),
    [orgRole, currentUser],
  );

  const isCustomerUser = useMemo(
    () => orgRole?.startsWith(`${OrgType.CUSTOMER}_`) || isCustomerUserProfile(currentUser),
    [orgRole, currentUser],
  );

  const tenantUserRoles = useMemo(() => {
    if (isPlatformUser) {
      return Object.values(Role);
    }
    return Object.values(Role).filter((role) => role !== Role.ADMIN);
  }, [isPlatformUser]);

  const customerUserRoles = useMemo(() => {
    return Object.values(Role).filter((role) => role === Role.VIEWER);
  }, []);

  return {
    tenantUserRoles,
    customerUserRoles,
    isPlatformUser,
    isTenantUser,
    isCustomerUser,
  };
};
